import * as React from 'react';
import { GroupSettings } from './index';
import { StudentData } from '../../models/Student';
import { GroupData } from '../../models/Group';
import * as GroupActions from '../../actions/group';
import { RouteComponentProps } from 'react-router';
import * as Modal from 'react-modal';
import { Popup } from '../Common/popup';

export namespace StudentContainer {
	export interface Props extends RouteComponentProps<void> {
		students: StudentData[];
		actions: Actions;
		student?: StudentData;
		hideCreate?: boolean;
	}

	export interface State {
		modalOpen: boolean;
	}

	export interface Actions {
		addStudent: (values: any) => void;
		selectStudent: (id: string) => void;
	}
}


export class StudentContainer extends React.Component<StudentContainer.Props, StudentContainer.State> {

	private firstname: HTMLInputElement;
	private lastname: HTMLInputElement;

	constructor(props: StudentContainer.Props) {
		super(props);
		this.state = {
			modalOpen: false
		}
	}

	openModal(e: any) {
		e.preventDefault();
		this.setState({ modalOpen: true });
	}

	closeModal(e?: any) {
		if (e)
			e.preventDefault();
		this.setState({ modalOpen: false });
	}

	addStudent(values: any) {
		this.closeModal();
		this.props.actions.addStudent(values);
	}

	render() {
		const { students, student } = this.props;
		var studentDOMs = [];
		for (var i = 0; i < students.length; i++) {
			let name = students[i].firstname + " " + students[i].lastname;
			let id = students[i]._id;
			let selectedClass = students[i] === student ? "am_selected" : ""
			studentDOMs.push(<div key={id} className={selectedClass} onClick={() => this.props.actions.selectStudent(id)}>{name}</div>);
		}

		let popupelement = (<div>
			<h4>Anna oppilaan nimi</h4>
			<Popup.Form
				inputs={[{ name: 'firstname', type: 'text', placeholder: 'etunimi' }, { name: 'lastname', type: 'text', placeholder: 'sukunimi' }]}
				buttons={[{ text: 'TALLENNA OPPILAS', image: '/images/GreenPlusButton.png' }]}
				accept={this.addStudent.bind(this)}
			/>
		</div>);

		let addStudentButton = <button onClick={this.openModal.bind(this)} className="btn am_green-button am_shadow col-12 m-1"><img src="/images/GreenPlusButton.png" className="am_smallicon"></img>LISÄÄ OPPILAS</button>;

		if (this.props.hideCreate) {
			addStudentButton = undefined;
		}

		return (
			<div>
				<p><b>Oppilaat</b></p>
				<div className="col-12 am_shortflex am_campaigns">
					{studentDOMs}
				</div>
				{addStudentButton}
				{/*<button className="btn am_green-button am_shadow col-12 m-1"><img src="/images/GreenUploadButton.png" className="am_smallicon"></img>TUO OPPILAITA TIEDOSTOISTA</button>*/}
				<Modal isOpen={this.state.modalOpen} contentLabel="Minimal Modal Example" style={Popup.modalStyle}>
					<Popup.Element element={popupelement} closeModal={this.closeModal.bind(this)} />
				</Modal>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/GroupSettings/studentcontainer.tsx